import $ from 'jquery';
import View from 'mixins/view';
import AbstractComment from '@ui/comments/comments-views/abstract-comment';
import AvatarView from '@ui/comments/avatar-view';
import { siteModel } from 'models/SiteModel';
import { repository } from 'repositories/loadCommentsAsync';
import CommentsService from '@ui/comments/CommentService';
import AddCommentView from '@ui/comments/add-comment-view';
import { pluralVariety } from '@utils/translations';

let eventListeners = [];
let refreshListeners = [];

export default class CommentReplyView extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`<div class="comments-list comments-list--level2"></div>`));
        this.showMoreTrigger = this.buildShowMoreTrigger();
        this.maxCommentsCollapsingLimit = 5;
        this.storedAddCommentValue = '';

        const id = this.model.get('id').toString();

        // pathname ends with id
        const isThreadMode = window.location.pathname.endsWith(id);

        const isExpanded = window.sessionStorage
          .getItem(id) || isThreadMode

        if (isExpanded) {
            // Hack: execute expand when constructor is done
            setTimeout(() => {
              this.expand();
            }, 0);
        } else {
          this.collapsed = (model.get('replies').length > this.maxCommentsCollapsingLimit);
        }

        const modelId = this.model.get('id');

        const handleRefreshedReplies = (event) => {
          const parentCommentId = parseInt(event.detail.parentCommentId);
          if (modelId !== parentCommentId) {
            return;
          }
          const model = event.detail.newCommentModel;

          const html = this.addComment(model);
          this.showMoreTrigger.before(html);
        };

        if (refreshListeners[modelId]) {
          document.removeEventListener('RefreshRepliesList',
            refreshListeners[modelId]);
        }
        refreshListeners[modelId] = handleRefreshedReplies;

        document.addEventListener('RefreshRepliesList',
          handleRefreshedReplies);

        const handleRefreshOnBufferedLiveComments = (event) => {
          if (!event.detail.replies[modelId]) {
            return;
          }

          const count = event.detail.replies[modelId];
          if (count) {
            this.updateLiveComments(count);
          }
        };

        if (eventListeners[modelId]) {
          document.removeEventListener('RefreshOnBufferedLiveComments',
            eventListeners[modelId]);
        }
        eventListeners[modelId] = handleRefreshOnBufferedLiveComments;

        document.addEventListener('RefreshOnBufferedLiveComments',
          handleRefreshOnBufferedLiveComments);
    }
    expand() {
        this.parentNode.expand();
        this.collapsed = false;
        const id = this.model.get('id');
        CommentsService.loadRepliesFromBuffer(id);
        if (!window.sessionStorage.getItem(`comment${id}`)) {
          window.sessionStorage.setItem(`comment${id}`, true);
        }
    }
    buildShowMoreTrigger() {
      return $(`<a href="#" class="c-comments__new-link fn-hidden"></a>`);
    }
    showCommentsTrigger(count = 0) {
        this.showMoreTrigger.html(`Pokaż ${count} ${ pluralVariety(count, 'nową odpowiedź', 'nowe odpowiedzi', 'nowych odpowiedzi') }`);
        this.showMoreTrigger.removeClass('fn-hidden');
    }
    enableLiveMode() {
        this.getModel().addEventListener('updatedPendingRepliesCounter', this::this.updateLiveComments);
    }
    updateLiveComments(updatedPendingRepliesCounter) {
        if (this.collapsed) {
          const bufferedModel = CommentsService
            .getBufferCommentsCollection()
            .findById(this.model.get('id'));
          const hiddenCommentsCount = (bufferedModel.get('replies').length
            - this.model.get('replies').length);
          this.showCommentsTrigger(hiddenCommentsCount);
          return;
        }
        this.showCommentsTrigger(updatedPendingRepliesCounter);
    }
    buildAddCommentView() {
        this.addCommentView = new AddCommentView(this.getModel());
        this.addCommentView.setReplyData();
        this.addChild(this.addCommentView);
    }
    setReplyMode(model) {
        this.expand();
        this.render();
        this.showMoreTrigger.addClass('fn-hidden');
        this.addCommentView.reply(model);
        this.addCommentView.render();
    }

    getCommentsContainer() {
      this.parentNode.getCommentsContainer();
    }
    showAllReplies(event) {
      if (event) {
        event.preventDefault();
      }
      this.expand();
      /*
       * Store content from reply form in variable
       */
      if (this.addCommentView !== void 0) {
        this.storedAddCommentValue = this.addCommentView.getValue();
      }

      this.render();
      this.showMoreTrigger.addClass('fn-hidden');
    }
    render() {
        const User = siteModel.get('User');
        const canReply = User.isLogged() && !User.isBanned();

        if (canReply) {
            this.buildAddCommentView();
            if (this.storedAddCommentValue) {
              /*
               * Retrieve stored content and fill form after rendering
               */
              this.addCommentView.setValue(this.storedAddCommentValue);
              this.storedAddCommentValue = '';
            }
            this.addCommentView.render();
            this.addCommentView.onValueChanged();
        }

        const comments = this.showComments();
        comments.forEach((comment) => {
          this.getRootEl().append(comment);
        });

        this.getRootEl().append(this.showMoreTrigger);
        this.showMoreTrigger.on('click', this.showAllReplies.bind(this));

        if (canReply) {
            this.rootEl.append(
                this.addCommentView.getRootEl()
            );
        }
    }
    getActiveFilter() {
        return this.parentNode.getActiveFilter();
    }
    showComments() {
        let comments = _.clone(this.model.get('replies'));

        const filter = CommentsService.getVisibleCommentsCollection().get('filter');
        if (filter === 'rating') {
            // order comments
            comments.sort((a, b) => {
                if (a.get('id') < b.get('id')) {
                    return -1;
                }
                return 1;
            });
        }

        this.rootEl.empty();

        if (this.collapsed) {
          const count = comments.length - 3;
          comments = _(comments)
            .slice(0, 3)
            .value();
          this.model.set('replies', comments);
          this.showCommentsTrigger(count);
        }

        let html = [];
        comments.forEach((comment) => {
          html.push(this.addComment(comment));
        });

        return html;
    }
    addComment(model) {
        const abstractComment = new AbstractComment(model);
        abstractComment.render();
        const commentView = abstractComment.getCommentView();

        if (commentView) {
          this.addChild(commentView);
          commentView.render();

          return commentView.getRootEl();
        }
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-reply-view.js